if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        const qty = opener.getAttribute('data-qty');
        const selectedVar = opener.getAttribute('data-variant-id');
        const selectedVarTitle = opener.getAttribute('data-selected-title');
        const line = opener.getAttribute('data-line-index');        
        // opener.classList.add('loading');
        // opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info[id^="CartProduct-"]');
                      
            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);
            // Developer 2026( Changed loop from true to false )
            const swiperContainer = this.modalContent.querySelector('.cart_quick-modify .product__media-list-main');
             if (!swiperContainer) return;          
              let sliderLength = swiperContainer.children[0].children.length;
              let result = (sliderLength > 1) ? true : false;          
              const swiper = new Swiper(swiperContainer, {
                slidesPerView: 1,
                speed: 500, 
                loop: false,
                navigation: {
                  nextEl: ".swiper-media-next",
                  prevEl: ".swiper-media-prev",
                },        
              });

            this.modalContent.querySelectorAll('fieldset.product-form__input').forEach(inputWrapper => {
              const dataId = $(inputWrapper).data('id');                
              const radioInputs = inputWrapper.querySelectorAll('input[type="radio"]');
                radioInputs.forEach(radioInput => {
                  if (radioInput.classList.contains('active__radio')) { 
                    radioInput.checked = true;
                    radioInput.dispatchEvent(new Event('change'));
                    const selectElements = Array.from(this.modalContent.querySelectorAll('.custm_drpdwn'));
                    const $select = selectElements.filter(function(selectElement) {
                      const container = $(selectElement).find('.size-list-container');
                      const dataIdFromContainer = container.data('id');                                                        
                      return dataIdFromContainer === dataId;                      
                    })[0];        

                    if ($select) {              
                      const $selectElement = $($select);
                        $selectElement.find('.selected-option').html(radioInput.value);                                                                         
                    }
                  }
                });
              }); 

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
              const mainContainer = this.modalContent.querySelector('.product-color-size-container');
              const qtyDropdownContainer = this.modalContent.querySelector('.quantity-dropdown__container');
              const qtyDropdownButton = qtyDropdownContainer.querySelector('.quantity-dropdown__button');
              const qtyDropdownList = qtyDropdownContainer.querySelector('.quantity-dropdown__list');
              const qtyHiddenInput = qtyDropdownContainer.querySelector('input[name="quantity"]');             
              if (qtyDropdownList && qtyHiddenInput) {
                const selectedQtyItem = qtyDropdownList.querySelector(`li[data-value="${qty}"]`);
                if (selectedQtyItem) {                 
                  qtyDropdownList.querySelectorAll('li').forEach(item => item.classList.remove('selected'));
                  selectedQtyItem.classList.add('selected');
                  qtyDropdownButton.querySelector('.selected-quantity').textContent = qty;                   
                  qtyHiddenInput.value = qty;                 
                  qtyHiddenInput.dispatchEvent(new Event('change', { bubbles: true }));
                }
              }           
            initializeDropdowns(qtyHiddenInput.value, line, selectedVar, mainContainer);           
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            // opener.classList.remove('loading');
            // opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
function initializeDropdowns(qty, lineIndex, vId, mainContainer) { 
  handleDropdown(mainContainer);
  
  document.addEventListener('click', function(event) {
    document.querySelectorAll('.size-list-container').forEach(function(dropdown) {
      const customButton = dropdown.closest('.custm_drpdwn').querySelector('.size-drpdwn-toggle.button');
      const isClickOutside = !customButton.contains(event.target) && !dropdown.contains(event.target);
      if (isClickOutside) {
        dropdown.classList.remove('show');
        dropdown.parentElement.classList.remove('show');
        dropdown.closest('.custm_drpdwn').classList.remove('show');
      }
    });
  });
  const oldVarId = vId;  
  document.querySelector('.update-cart-product-global').addEventListener('click', function(e) {
    e.preventDefault();

    const quantityContainer = this.closest('.product__info-container');
    const qty = quantityContainer.querySelector('input#selected-quantity').value;
    const newId = quantityContainer.querySelector('input[name="id"]').value;

    modifyLineItem(qty, lineIndex, newId, oldVarId);
  });
}

function handleDropdown(mainContainer) {
  const $container = mainContainer

  $container.addEventListener('click', function(event) {
    const $customButton = event.target.closest('.size-drpdwn-toggle.button');

    if ($customButton) {
      event.stopPropagation(); 
      const dropdownID = $customButton.closest('.custm_drpdwn').querySelector('.size-list-container').getAttribute('data-id');
      const $dropdown = $customButton.closest('.custm_drpdwn').querySelector(`.size-list-container[data-id="${dropdownID}"]`);
      const $dropdownItems = $dropdown.querySelectorAll('li span');
      const $fieldset = document.querySelector(`fieldset[data-id="${dropdownID}"]`);
      const $realDropdown = document.getElementById(dropdownID);
    
      const isShown = $dropdown.classList.toggle('show');
      $customButton.closest('.custm_drpdwn').classList.toggle('show');
      $dropdown.parentElement.classList.toggle('show', isShown);

      if (isShown) {
        $dropdownItems.forEach(item => {
          item.onclick = function(event) {
            handleDropdownItemClick(event, $dropdown, $dropdownItems, $customButton, $fieldset, $realDropdown);
          };
        });
      } else {
        $dropdownItems.forEach(item => {
          item.onclick = null; 
        });
      }

      function handleDropdownItemClick(event, $dropdown, $dropdownItems, $customButton, $fieldset, $realDropdown) {
      const targetItem = event.target.closest('li');
      if (targetItem.classList.contains('unavailable')) {
        return; 
      }
     
      updateSelectedItem($dropdownItems, targetItem, $customButton);
            
      const selectedValue = targetItem.getAttribute('data-value');
      const $radioButton = $fieldset.querySelector('input[type="radio"][value="' + selectedValue + '"]');
      if ($radioButton) {
        $radioButton.checked = true;
        const changeEvent = new Event('change', { bubbles: true });
        $radioButton.dispatchEvent(changeEvent);         
      }
      $dropdown.classList.remove('show');
      $customButton.closest('.custm_drpdwn').classList.remove('show');
      $dropdown.parentElement.classList.remove('show');
      // $dropdownItems.off('click');         
    }
    }
  });
 
  document.addEventListener('click', function(event) {
    const $dropdown = document.querySelector('.size-list-container.show');    
    if ($dropdown && !$dropdown.contains(event.target)) {
      const $custmDropdown = $dropdown.closest('.custm_drpdwn');
      const $customButton = $custmDropdown ? $custmDropdown.querySelector('.size-drpdwn-toggle.button') : null;
      $dropdown.classList.remove('show');
      $customButton.closest('.custm_drpdwn').classList.remove('show');
      $dropdown.parentElement.classList.remove('show');
    }
  });
}

$(document).ready(function() {
   $('body').on('click', '.quantity-dropdown__button', function() {
    $(this).next('.quantity-dropdown__list').toggleClass('show');
  });

  $('body').on('click', '.quantity-dropdown__list li', function() {
    const selectedValue = $(this).data('value');
    const $dropdownContainer = $(this).closest('.quantity-dropdown__container');
  
    $dropdownContainer.find('.selected-quantity').text(selectedValue);   
    $dropdownContainer.find('input[name="quantity"]').val(selectedValue);
    $dropdownContainer.find('.quantity-dropdown__list').removeClass('show');          
  });

  $(document).on('click', function(event) {
    if (!$(event.target).closest('.quantity-dropdown__container').length) {
      $('.quantity-dropdown__list').removeClass('show');
    }
  }); 
});

function extraProductInfo(varId) { 
  const input = document.querySelector('input[name="id"]');
  input.value = varId;
  input.dispatchEvent(new Event('change', { bubbles: true }));

  const variantSpan = document.querySelector(`span[id="${varId}"]`);
  const maxQty = variantSpan ? parseInt(variantSpan.dataset.qty, 10) : 0;

  const quantityDropdown = document.querySelector('.quantity-dropdown__list');
  const quantityInput = document.querySelector('input[name="quantity"]');

  // Get currently selected qty
  let currentSelectedValue = parseInt(quantityInput.value, 10) || 1;

  const itemCount = maxQty > 5 ? 5 : maxQty;

  // KEEP qty if available otherwise set 1
  if (currentSelectedValue > itemCount) {
    currentSelectedValue = 1;
  }

  // Rebuild dropdown
  quantityDropdown.innerHTML = '';

  for (let i = 1; i <= itemCount; i++) {
    const li = document.createElement('li');

    li.setAttribute('data-value', i);
    li.innerHTML = `<span>${i}</span>`;

    if (i === currentSelectedValue) {
      li.classList.add('selected');
    }

    quantityDropdown.appendChild(li);
  }

  // Update UI
  document.querySelector('.selected-quantity').textContent = currentSelectedValue;

  quantityInput.value = currentSelectedValue;

  quantityInput.dispatchEvent(
    new Event('change', { bubbles: true })
  );

  quantityDropdown.setAttribute('data-max', maxQty);
}
function modifyLineItem(qty, lineIndex, newVariantId, oldVarId) {
    const quantity = qty;
    const line = lineIndex;
    const variantId = newVariantId;  
    const oldVariantId = oldVarId;   
    const cartItemsElement = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');  
    const itemId = document.querySelector(`#CartItem-${lineIndex}`)?.dataset.itemId;
    const quickAddModal = document.querySelector(`#QuickAdd-${itemId}`);
    const modalCloseButton = document.querySelector(`#ModalClose-${itemId}`);

    const maxQty = parseInt(
      document.querySelector('.quantity-dropdown__list').dataset.max,
      10
    );

    const finalQty = Math.min(parseInt(quantity, 10), maxQty);

    if (cartItemsElement) {
        if (newVariantId === oldVariantId) {         
            cartItemsElement.updateQuantity(line, finalQty, 'quantity', newVariantId)
                .then(() => {                                    
                    if (quickAddModal && modalCloseButton) {
                        modalCloseButton.click();
                    }                 
                })
                .catch(error => {
                    console.error('Error updating quantity:', error);
                });
        } else {         
            $.ajax({
                url: '/cart/add.js',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    id: variantId,
                    quantity: finalQty
                }),
                dataType: 'json'
            })
            .then(response => {              
                updateCartCount(response);               
              const sectionId = document.getElementById('main-cart-items').dataset.id;
              return fetch(`${routes.cart_url}?section_id=${sectionId}`);
            })
            .then(response => response.text())
            .then(responseText => {               
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const updatedCartHtml = html.querySelector('cart-items') || html.querySelector('cart-drawer-items');
                if (updatedCartHtml) {
                    cartItemsElement.innerHTML = updatedCartHtml.innerHTML;
                } else {
                    console.error('Failed to find updated cart HTML.');
                }                
                return findLineItemByVariantId(oldVariantId);
            })
            .then(oldLineItem => {
                if (oldLineItem) {                     
                    return cartItemsElement.updateQuantity(oldLineItem.line, 0, 'quantity', oldVariantId);
                } else {
                    console.warn('Old variant not found in the cart.');
                }
            })
            .then(() => {               
                if (quickAddModal && modalCloseButton) {
                    modalCloseButton.click();
                }
            })
            .catch(error => {
                console.error('Error updating or removing variant:', error);
            });
        }
    }
}

function findLineItemByVariantId(variantId) {
  return fetch(`${routes.cart_url}?section_id=main-cart-items`)
    .then(response => response.text())
    .then(responseText => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const lineItemElement = html.querySelector(`[data-variant-id="${variantId}"]`);
      if (lineItemElement) {
        return {
          line: parseInt(lineItemElement.dataset.line, 10)
        };
      }
      return null;
    })
    .catch(e => {
    });
}
function updateSelectedItem($dropdownItems, targetItem, $customButton) { 
  $dropdownItems.forEach(item => item.closest('li').classList.remove('selected'));
  targetItem.classList.add('selected');

  const selectedText = targetItem.textContent;
  const selectedValue = targetItem.getAttribute('data-value');
  $customButton.querySelector('.selected-option').textContent = selectedValue;
}
function updateCartCount(cartData) {
  try {
      setTimeout(function () {
        $.getJSON('/cart.json').then(cart => {
            fetch('/cart?view=item').then(response => response.text())
            .then(text => {
                const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
                const cartFormInnerHTML = sectionInnerHTML.getElementById('CartDrawer').innerHTML;              
                const totalPrice = sectionInnerHTML.querySelector('#CartDrawer .totals__total-value');               
                if (totalPrice) {                             
                  $('.main_total_mobile .totals__total-value').html(totalPrice.innerHTML);
                }               
              if($('#cart-icon-bubble .cart-count-bubble').length===0){
                const cartNumber=document.createElement('div')
                cartNumber.className='cart-count-bubble'
                cartNumber.innerHTML=`
                <span aria-hidden="true">${cart.item_count}</span>
                <span class="visually-hidden">${cart.item_count} items</span>
                `
                $('#cart-icon-bubble').append(cartNumber)
              }else{
                 $('.cart-count-bubble span[aria-hidden="true"]').each((_,count)=>$(count).text(cart.item_count))
              }              
            })
        });
      }, 1500);
    } catch (e) {
      console.warn(e);
    }
}